import {block} from '../utils/cn';

export const progressBlock = block('progress');
